import snsAxiosClient from '../common/http/http-sns';
import formatString from '../utils/formatString';
import { get } from 'lodash';

export type DriverTipType = {
  tipPercentage: string;
  tipAmount?: number;
  preferences?: boolean;
  tipRoundedAmount?: number;
};

function updateDriverTipService(environmentVariables, user, driverTip: DriverTipType) {
  const options = {
    headers: {
      ...get(environmentVariables, 'API_HEADERS_PATCH_V1'),
      Authorization: `Bearer ${get(user, 'authToken')}`,
    },
  };
  return snsAxiosClient(options).patch(
    formatString(get(environmentVariables, 'SNS_UPDATE_DRIVER_TIP', 'update_driver_tip'), {
      UUID: get(user, 'UUID'),
    }),
    driverTip,
  );
}

export default updateDriverTipService;
